import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { SERVER, LOGON_INFO, COMP_TYPE } from "../app.constants";
import { CommonService } from "../app.service";
import { User } from "./user.service";
import { Member } from "./member-register.service";


@Injectable()
export class CompanyService {

    login_user_id: string;
    login_comp_id: string;
    login_parent_comp_id: string;

    constructor(
        private _htc: HttpClient,
        private commonService: CommonService
    ) {
        this.login_user_id = LOGON_INFO.USER_ID;
        this.login_comp_id = LOGON_INFO.COMP_ID;
        this.login_parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
    }

    //会社リスト取得
    getCompanyList(page: number, isDeleteCompany: boolean, isLargeResult: boolean): Observable<Company[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Company[]>(SERVER.baseURL+'/company-list/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteCompany.toString()+'/'+isLargeResult.toString()+'/'+LOGON_INFO.USER_ID, {params: params});
    }

    //営業所リスト取得（combobox用）
    getCompanyListForCombo(): Company[] {
        return JSON.parse(sessionStorage.getItem("company_list_for_combobox"));
    }
    fetchCompanyListForCombo(): Promise<any> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('page', '1');
            this._htc.get<Company[]>(SERVER.baseURL+'/company-list/'+LOGON_INFO.PARENT_COMP_ID+'/false/true/'+LOGON_INFO.USER_ID, {params: params})
                .subscribe(
                    data => {
                        const compList: Company[] = [];

                        for(let i=0; i<data['results'].length; i++) {
                            let comp: Company = Object.assign({}, data['results'][i]);
                            comp.name = "【" + comp.group_name + "】" + comp.name;
                            // (2024.02)マルチセレクト対応（初期化）
                            comp.is_selected = false;
                            compList.push(comp);
                        }

                        sessionStorage.setItem("company_list_for_combobox", JSON.stringify(compList));
                        resolve(null);
                    }
                    ,error => {
                        reject(null);
                    }
                );
        });
    }

    //会社情報取得
    getCompanyInfo(comp_id: string): Observable<Company> {
        return this._htc.get<Company>(SERVER.baseURL+'/company-info/'+comp_id+'/');
    }

    //傭車先リスト取得
    getPartnerList(page: number, isDeleteCompany: boolean, isLargeResult: boolean): Observable<Company[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Company[]>(SERVER.baseURL+'/partner-list/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteCompany.toString()+'/'+isLargeResult.toString()+'/', {params: params});
    }

    //荷主リスト取得
    getClientList(page: number, isDeleteCompany: boolean): Observable<Company[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Company[]>(SERVER.baseURL+'/client-list/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteCompany.toString()+'/'+LOGON_INFO.USER_ID, {params: params});
    }

    //会社新規登録
    registCompany(company: Company): Observable<Company> {
        this.setParam(company);
        return this._htc.post<Company>(SERVER.baseURL+'/company-regist/', JSON.stringify(company));
    }

    //会社情報を更新
    updateCompany(company: Company): Observable<Company> {
        this.setParam(company);
        return this._htc.put<Company>(SERVER.baseURL+'/company-update/'+company.comp_id+'/', JSON.stringify(company));
    }

    //会社情報を更新
    updateCompanyWithUser(member: Member): Observable<Company> {
        this.setParam(member.company);
        member.user.update_id = this.login_user_id;
        return this._htc.put<Company>(SERVER.baseURL+'/company-update-withuser/'+member.company.comp_id+'/', JSON.stringify(member));
    }

    //会社情報削除
    deleteCompany(comp_id: string) {
        return this._htc.put<Company>(SERVER.baseURL+'/company-delete/'+comp_id+'/', JSON.stringify({update_id: this.login_user_id}));
    }

    private setParam(company: Company) {
        company.create_id = this.login_user_id;
        company.update_id = this.login_user_id;
        // (2024.03)登録者が「首都圏管理」の場合、「大興本社」のcomp_idを設定する
        company.parent_comp_id = this.login_parent_comp_id;
        company.address_lat  = this.commonService.decimalRound(company.address_lat, 6);
        company.address_lng = this.commonService.decimalRound(company.address_lng, 6);
        company.group_name = company.comp_type == COMP_TYPE.PARTNER ? company.group_name : company.parent_group_name;

        console.log('comp', company);
    }

}



export class Company {
    comp_id: string;
    parent_comp_id: string;
    name: string;
    group_name: string;
    parent_group_name: string;
    comp_type: string;
    comp_type_name: string;
    menu_type: string;
    zipcode: string;
    address: string;
    address_detail: string;
    address_lat: number;
    address_lng: number;
    tel: string;
    fax: string;
    email: string;
    emailConfirm: string;
    etc: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_name: string;
    update_date: Date;
    user: User[];

    // (2024.02)マルチセレクト対応
    is_selected: boolean;
}

export class CompanyForPrint {
    client_comp_info: string;
    trans_comp_info: string;
}



// WEBPACK FOOTER //
// ./src/app/member-kanri/company.service.ts